import React, { useState, useEffect } from "react";
// import CustomTable from '../../../../customComponents/CustomTable';
// import './index.scss';
// import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import SearchInput from "../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import searchIcon from "../../../../Assets/icons/searchicon.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import CustomTable from "../../../customComponents/CustomTable";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import download from "../../../../Assets/icons/download.svg";
import viewIcon from "../../../../Assets/icons/eye 1.svg";
import mailIcon from "../../../../Assets/icons/mailIcon.svg";
import * as base64 from "base-64";
import { showAlert } from "../../../customComponents/CustomSweetAlert/ShowAlert";

const CustomerPurchaseOrder = () => {
  const [productData, setProductData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalInactive, setTotalInactive] = useState(0);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealer_id = localStorage.getItem("dealerId");

  const fetchProductList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/customer-po/list",
        {
          orderBy: "postockinsr_id desc",
          page,
          pageSize,
          searchText: searchTerm,
          startDate: null,
          endDate: null,
          dealer_id: dealer_id,
          checkCustomerTypeOrder:"C"
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1 + page * pageSize,
        serial_no: item.serial_no || "--",
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setProductData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchProductList(newPage);
  };

  const handleViewButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.VIEWCUSTOMERPURCHASEORDER}`, {
      state: { data: rowData },
    });
  };

  const TABLE_HEADERS = [
    // "Sr No.",
    // "Product ID",
    "Customer Name",
    "Mobile No.",
    // "Variant Name",
    // "Item Name",
    // "Vin No.",
    // "Serial No",
    "Delivery Date",
    "Final Price",
    "Action",
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",
    // "Product ID": "product_id",
    "Customer Name": "full_name",
    "Mobile No.": "mobile_no",
    "Variant Name": "variant_name",
    "Item Name": "item_name",
    "Vin No.": "vin_no",
    "Serial No": "serial_no",
    "Delivery Date": "customer_delivery_date",
    "Final Price": "total_price",
    Action: [
      { type: "view", icon: viewIcon, label: "view" },
      {
        type: "printCustomerPurchaseOrder",
        icon: download,
        label: "Print",
      },
      // { type: "mail", icon: mailIcon, label: "Mail" },
      // { type: "edit", icon: editIcon, label: "Edit" },
    ],
  };

  useEffect(() => {
    if (searchTerm === "") {
      fetchProductList();
    }
  }, [searchTerm]);
  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITCUSTOMERPURCHASEORDER}`, {
      state: { data: rowData },
    });
  };

  // const DownLoadPdf = (row) => {
  //   console.log("row", row.postockinsr_id);
  //   var text = row?.postockinsr_id;
  //   var encoded = base64.encode(text);
  //   const pdfURL = `${process.env.REACT_APP_API_BASE_URL}customer-po/customer-wise-inovice/${encoded}`;
  //   window.open(pdfURL, "_blank", "noopener,noreferrer");
  // }

  const DownLoadPdf = async (row) => {
    try {
      var text = row?.postockinsr_id;
      var encoded = base64.encode(text);

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}customer-po/customer-wise-inovice/${encoded}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
          },
        },
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `invoice_${row?.postockinsr_id}.pdf`; // file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const handleMailFunc = async (row) => {
    const text = row?.postockinsr_id;
    const encoded = base64.encode(text);

    try {
      const response = await axiosInstance.get(
        `/purchaseorder/attchement-send-emailto-customer/${encoded}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Email sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="OnboardManagamentContainer">
              <div className="OnboardManagamentbuttonContainer customer-purchase-order-heading">
                {/* <div style={{fontSize:"12px",color:"lightgrey"}} >Sales / Customer Purchase Order</div> */}
                <h5
                  className="customer-purchase-order-header"
                  style={{ fontWeight: "600" }}
                >
                  Customer Purchase Order
                </h5>
              </div>
              <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
                <button
                  className="addcustomerbutton"
                  onClick={() =>
                    navigate(ROUTES_NAVIGATION.ADDCUSTOMERPURCHASEORDER)
                  }
                >
                  Add Order
                </button>
              </div>
            </div>
            <div className="tableWrapper">
              <div className="admin-list-container">
                <div className="listsearchContainer">
                  <h5 style={{ fontWeight: "600" }}>Order List</h5>
                  <div>
                    <SearchInput
                      placeholder="Search Order"
                      onSearch={fetchProductList}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                </div>
              </div>
              <CustomTable
                data={productData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
                pdfDownLoad={DownLoadPdf}
                handleViewButton={handleViewButton}
                handleMailFunc={handleMailFunc}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomerPurchaseOrder;
